import { motion } from "framer-motion";
import { useTilt, Glare } from "@/components/marketing/Depth4D";

export const BentoFeatureCard = ({ icon: Icon, title, desc, span = "md:col-span-4", accent, index = 0 }) => {
  const tilt = useTilt(6);
  return (
  <motion.div
    {...tilt.handlers}
    style={tilt.style}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: index * 0.08 }}
    whileHover={{ y: -6 }}
    className={`group lux-card p-6 sm:p-7 relative overflow-hidden transition-[border-color,box-shadow] duration-300 hover:border-white/15 hover:shadow-[0_20px_60px_-30px_rgba(0,0,0,0.6)] ${span}`}
    data-testid="bento-feature-card">
    {accent && <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#D4AF37]/8 blur-3xl pointer-events-none" />}
    <Glare glare={tilt.glare} />
    <div className="w-11 h-11 rounded-xl bg-[#D4AF37]/12 flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110">
      <Icon className="w-5 h-5 text-[#D4AF37]" />
    </div>
    <h3 className="font-serif-lux text-2xl leading-tight text-white">{title}</h3>
    <p className="text-sm text-white/55 mt-2.5 leading-relaxed">{desc}</p>
  </motion.div>
);
};
